import {
  AuthenticationResult,
  InteractionRequiredAuthError,
} from "@azure/msal-browser"
import { loginRequest } from "./authConfig"
import { msalInstance } from "../msalInstance"

export async function acquireToken(): Promise<string | null> {
  try {
    const response: AuthenticationResult =
      await msalInstance.acquireTokenSilent(loginRequest)
    return response.accessToken
  } catch (error) {
    if (error instanceof InteractionRequiredAuthError) {
      msalInstance.acquireTokenRedirect(loginRequest)
      return null
    } else {
      console.error(error)
      return null
    }
  }
}
